module.exports = __webpack_public_path__ + "static/share-13fe00e190b2adca222a055452139dfd.png";